import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from 'ui/src/components/Heading/Heading'

type Props = {
  score: number
  maxScore: number
} & Partial<Omit<ComponentProps<typeof Heading>, 'children'>>

export const AverageRating = ({ score, maxScore, ...others }: Props) => {
  const { t } = useTranslation('reviews')

  return (
    <Heading variant={{ _: 'standard.72', sm: 'standard.96' }} color="textPrimary" align="center" {...others}>
      {t('RATING_SCORE_LABEL', { score, maxScore })}
    </Heading>
  )
}
